import React, { useState } from "react";
import { Input, Row, Button, Col, notification, Form } from "antd";
import ThemeDatePicker from "../../components/ThemeDatePicker";
import dayjs from "dayjs";
import { useSocket } from "../../components/Socket";
// import { ReactTransliterate } from "react-transliterate";
// import "react-transliterate/dist/index.css";

const { TextArea } = Input;

const Broadcast = () => {
  const [form] = Form.useForm();
  const socketContext = useSocket();
  const { doSend } = socketContext;
  // Add this state to control the input text
  // const [text, setText] = useState("");

  const handleSendMessage = () => {
    const payload = form.getFieldsValue();
    doSend({
      event: "saveNotifications",
      payload: {
        type: "broadcast",
        message: payload?.textArea,
        expiry: payload?.date?.$d,
      },
    });
    form.resetFields();
    // setText(""); // Clear the text state as well
    notification.success({ message: "Message Sent Successfully" });
  };

  const handlefailed = (value) => {
    console.log("value", value);
  };

  // Function to handle transliteration changes
  // const handleTransliterateChange = (e) => {
  //   console.log("text", e.target.value);
  //   setText(e.target.value);
  //   form.setFieldsValue({ textArea: e.target.value });
  // };

  return (
    <Form
      form={form}
      onFinish={handleSendMessage}
      onFinishFailed={handlefailed}
      style={{ marginTop: "3rem" }}
    >
      <Col
        xs={24}
        sm={24}
        md={8}
        lg={6}
        xl={4}
        style={{ margin: "0 0 1rem 1rem" }}
      >
        <ThemeDatePicker
          title="Date"
          width="100%"
          showTime={{
            format: "HH:mm",
            defaultValue: dayjs().hour(0).minute(0),
          }}
          format="YYYY-MM-DD HH:mm"
          name="date"
          placeholder="Select Date"
          mobileHeight="2rem"
          formProps={{
            name: "date",
            rules: [{ required: true }],
          }}
        />
      </Col>
      <Form.Item name="textArea" rules={[{ required: true }]}>
        {/* <ReactTransliterate
          value={text}
          onChange={handleTransliterateChange}
          lang="gu"
          placeholder="Type in English, it will convert to Gujarati"
          containerStyles={{
            width: "100%",
          }}
          typingTimeout={300}
          renderComponent={(props) => (
            <TextArea
              {...props}
              rows={5}
              placeholder="Enter your message (type in English for Gujarati)"
            />
          )}
        /> */}
        <TextArea name="textArea" rows={5} placeholder="Enter your message" />
      </Form.Item>
      <Row justify="end" style={{ marginTop: "1rem" }}>
        <Button type="primary" htmlType="submit">
          Send
        </Button>
      </Row>
    </Form>
  );
};

export default Broadcast;
